import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreOfferDetails as orgModuleConfig } from 'org/configs/modules.config';
import orgConfig from 'org/configs/org.config';

const { instoreLabel } = orgConfig;

const defaultConfig = {
  defaults: {
    wasLinkedInstoreLabel: instoreLabel,
    justLinkedInstoreLabel: instoreLabel,
  },
};

export default mergeModuleConfigs(defaultConfig, orgModuleConfig);
